import { request } from './http-client';
import { TParams } from './types';
import { ISingleOrder } from './types/orders';

const orderService = {
  getList: (id: string, params: TParams, headers?: Record<any, any>) =>
    request.get<{ orders: ISingleOrder[]; count: number | string }>(
      `/v2/customers/${id}/orders`,
      {
        params,
        headers,
      }
    ),
  getById: (id: string, config?: any) =>
    request.get<ISingleOrder>('/v2/mika/order/' + id, config),
  create: (data: any, shipperId?: string) =>
    request.post('/v2/ondemand-order', data, {
      headers: shipperId ? { Shipper: shipperId } : undefined,
    }),
  cancelOrder: (id: string, config?: any) =>
    request.patch('/v2/order/' + id + '/cancel-order', {}, config),

  update: (id: string, data: any) => request.put('/v1/customers/' + id, data),
  getActiveCount: (params?: any) =>
    request.get('/v1/customers/active-orders-count', { params }),
};

export const orderServiceMika = {
  getList: async (id: string, params: TParams) => {
    const res = await request.get<{
      orders: ISingleOrder[];
      count: number | string;
    }>(`/v2/mika/customers/${id}/orders`, { params });

    return res.data;
  },
};

export default orderService;
